// extracted by mini-css-extract-plugin
export default {"trucks-head":"Filter_trucks-head__YNV2Y","trucks":"Filter_trucks__1Pb+-","filterss":"Filter_filterss__+mF5v"};